/**
 * Gallery — PhotoSwipe v5 lightbox.
 *
 * Initializes a PhotoSwipe lightbox for each .gallery-items list.
 * Reads slide data (full image URL, dimensions, caption) from
 * data attributes on the <a> elements.
 *
 * @package Hive
 */

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

function initGalleries() {
  const galleries = document.querySelectorAll('.gallery-items');

  if (!galleries.length) return;

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  galleries.forEach((gallery) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: gallery,
      children: 'a[data-pswp-width]',

      pswpModule: () => import('photoswipe'),

      showAnimationDuration: prefersReducedMotion ? 0 : 250,
      hideAnimationDuration: prefersReducedMotion ? 0 : 250,
      zoomAnimationDuration: prefersReducedMotion ? 0 : 250,

      paddingFn: (viewportSize) => {
        if (viewportSize.x < 600) {
          return { top: 20, bottom: 20, left: 10, right: 10 };
        }
        return { top: 40, bottom: 40, left: 80, right: 80 };
      },

      closeOnVerticalDrag: true,
      pinchToClose: true,
    });

    // Custom caption element
    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        onInit: (el) => {
          el.classList.add('pswp__custom-caption');

          lightbox.pswp.on('change', () => {
            const slide = lightbox.pswp.currSlide;
            const caption = slide.data.element?.dataset.pswpCaption || '';

            el.innerHTML = caption ? `<span>${caption}</span>` : '';
            el.style.display = caption ? 'block' : 'none';
          });
        },
      });
    });

    // Disable the blurry thumbnail placeholder — just show the
    // dark overlay until the full image loads.
    lightbox.addFilter('placeholderSrc', () => false);

    lightbox.init();
  });
}

document.addEventListener('DOMContentLoaded', initGalleries);
